import { create } from 'zustand';
import { AnswerQuotation } from '../../../../../@types/interface';

interface SelectedAnswerStore {
  answer: AnswerQuotation | null;
  onSelect: (answer: AnswerQuotation) => void;
  onClear: () => void;
}

const useSelectedAnswerAgent = create<SelectedAnswerStore>(set => ({
  answer: null,
  onSelect: async (answer: AnswerQuotation) => {
    set({ answer });
  },
  onClear: () => {
    set({ answer: null });
  },
}));

export default useSelectedAnswerAgent;
